"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SetItem = exports.RemoveItem = exports.GetItem = void 0;
var LocalStoreMethods = _interopRequireWildcard(require("./LocalStore"));
var _function = require("../type-checks/function");
var _object = require("../type-checks/object");
var _string = require("../type-checks/string");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const
  /**
   * Gets value from local storage
   *
   * @name LocalStore.GetItem
   * @param {string} key Key in local storage
   * @returns {string} Value from local storage (or null if not present)
   */
  GetItem = key => {
    let result = null;
    if (typeof window === "object" && (0, _object.isObject)(window.localStorage) && (0, _function.isFunction)(window.localStorage.getItem) && (0, _string.isStringOfLength)(key)) {
      result = window.localStorage.getItem(key);
    }
    return result;
  },
  /**
  * Removes value from local storage
  *
  * @name LocalStore.RemoveItem
  * @param {string} key Key in local storage
  * @returns {object} null if successful, string of value if unsuccessful
  */
  RemoveItem = key => {
    if (typeof window === "object" && (0, _object.isObject)(window.localStorage) && (0, _function.isFunction)(window.localStorage.removeItem) && (0, _string.isStringOfLength)(key)) {
      window.localStorage.removeItem(key);
    }
    return LocalStoreMethods.GetItem(key);
  },
  /**
  * Adds custom data injected indicator attribute to links in a content fragment
  *
  * @name LocalStore.SetItem
  * @param {string} key Key to assign value to
  * @param {string} value Value to save
  * @returns {string} Saved value (or null if unsuccessful)
  */
  SetItem = (key, value) => {
    if (typeof window === "object" && (0, _object.isObject)(window.localStorage) && (0, _function.isFunction)(window.localStorage.setItem) && (0, _string.isStringOfLength)(key) && (0, _string.isString)(value)) {
      window.localStorage.setItem(key, value);
    }
    return LocalStoreMethods.GetItem(key);
  },
  LocalStore = {
    GetItem: GetItem,
    RemoveItem: RemoveItem,
    SetItem: SetItem
  };
exports.SetItem = SetItem;
exports.RemoveItem = RemoveItem;
exports.GetItem = GetItem;
var _default = exports.default = LocalStore;